// Registro del Service Worker, siguiendo el patrón que usa el template
// PWA de Create React App, pero simplificado: nuestro service-worker.js
// (en public/) no cachea nada, así que no necesitamos la lógica de
// validación de precache que trae el template oficial.
//
// Se registra solo en producción y solo si el navegador lo soporta.
// Esto es lo que permite que Chrome/Android considere el sitio
// "instalable" y dispare `beforeinstallprompt`.

export function register() {
  if (process.env.NODE_ENV !== 'production') return
  if (!('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`

    navigator.serviceWorker.register(swUrl).catch((error) => {
      console.error(
        'Error al registrar el Service Worker de Franco Frutt:',
        error
      )
    })
  })
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return

  navigator.serviceWorker.ready
    .then((registration) => {
      registration.unregister()
    })
    .catch((error) => {
      console.error(error.message)
    })
}
